/* 布局 */
//前台
import Layout from "@views/layout";

const teateachingRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "teateaching",
            name: "TEATEACHING",
            meta: {
                title: "教师备课表",
                sort: 1,
            },
            component: () => import("@views/business/teateaching/index.vue"),
            redirect: {
                name: "TEATEACHING_LIST",
            },
            children: [
                {
                    path: "list/:sccou_cha_id",
                    name: "TEATEACHING_LIST",
                    meta: {
                        title: "教师备课表",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/teateaching/list.vue"),
                },
                                {
                    path: "add/:sccou_cha_id",
                    name: "TEATEACHING_ADD",
                    meta: {
                        title: "新增教师备课表",
                        parentPath: '/business/teateaching/list',
                        operate: true,
                    },
                    component: () => import("@views/business/teateaching/form.vue"),
                },
                                                {
                    path: "edit/:teteaId",
                    name: "TEATEACHING_EDIT",
                    meta: {
                        title: "编辑教师备课表",
                        parentPath: '/business/teateaching/list',
                        operate: true,
                    },
                    component: () => import("@views/business/teateaching/form.vue"),
                },
                                        ],
    },


        ],
};

export default teateachingRouter;
